import React, {useState, useEffect, useContext} from "react";
import UserAddressesPage from "../../../pages/user/UserAddressesPage";
import UserProfileContext from "../../../context/userProfile/UserProfileContext";
import {Box} from "@mui/material";

const SelectAddressStep = ({setCompleted, selAddress, setSelAddress}) => {
  const userProfileContext = useContext(UserProfileContext);
  const [selectedAddress, setSelectedAddress] = useState(null);

  useEffect(() => {
    if (selAddress !== null && selAddress !== undefined) {
      setSelectedAddress(selAddress);
      setCompleted(true);
    } else {
      // Auto-select default or first address if available
      const addresses = userProfileContext?.state?.addresses || [];
      if (addresses.length > 0) {
        const defaultAddr = addresses.find((a) => a.isDefault) || addresses[0];
        setSelectedAddress(defaultAddr);
        setSelAddress(defaultAddr);
        setCompleted(true);
      }
    }
  }, [userProfileContext?.state?.addresses]);

  useEffect(() => {
    if (selectedAddress !== null) {
      setSelAddress(selectedAddress);
      setCompleted(true);
    }
  }, [selectedAddress]);

  return (
    <Box sx={{py: {xs: 1, sm: 1.5}}}>
      <UserAddressesPage
        selectAddress={true}
        selectedAddress={selectedAddress}
        setSelectedAddress={setSelectedAddress}
      />
    </Box>
  );
};

export default SelectAddressStep;
